import { gql } from '@apollo/client';

export const ALL_ASSIGNED_REGISTRATIONS = gql`
  query AllAssignedRegistrations($input: ECDRegistrationInput!) {
    ecdRegistrations: allAssignedRegistrations(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id

          afterCareComments
          applicationCollectionType
          applicationNotes
          applicationSubmissionType
          approvalStatus
          approved
          approvedBy {
            id
            firstName
            lastName
          }
          assessEcdFrameworkOnline
          assessmentNotes
          associatedEcdInstitution {
            id
            name
            numberOfChildrenEnrolled
            socialServicesProfessional {
              id
              firstName
              lastName
            }
            sspSupervisor {
              id
              firstName
              lastName
            }
          }
          certificateNumber
          dateAssigned
          dateAttended
          dateCertificateReceivedFromDistrict
          dateCollected
          dateEHPReportReceived
          dateCertificateDispensed
          dateFileCompilationSubmitted
          dateIdentified
          dateInvited
          dateOfDSDSiteVisit
          dateOfEHPSiteVisit
          dateProgCertificateReceivedFromDistrict
          dateProgCertificateDispensed
          dateSubmissionCompleted
          dateSubmitted
          expiryDate
          frameworkAnswers {
            id
            question {
              id
              title
              name
              tag
            }
            answer
            files {
              id
              name
              url
            }
          }
          generalSafetyComments
          identifiedBy
          issueDate
          lastDateModified
          newOrRenewal
          numberOfChildrenPresent
          numberOfStaffPresent
          otherAssessmentDelayReasons
          pcrLevel
          progCertificateExpiryDate
          progCertificateIssueDate
          progCertificateNumber
          progLevel
          programmeAssessmentOutcome
          progRegistrationOutcome
          providedDocuments {
            id
            document {
              id
              name
            }
            provided
          }
          reasonForAssessmentDelay
          reasonForCertificationDelay
          reasonForProgCertificationDelay
          reasonForRejection
          progReasonForRejection
          registrationOutcome
          registrationType {
            id
            name
          }
          siteAssessmentOutcome
          submissionNumber
          submitted
          transportComments
        }
      }
    }
  }
`;
